import type { BubblePointPressurePSIACalculator } from "../../d";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const bubblePointPressurePSIACalculator: BubblePointPressurePSIACalculator =
  params => {
    const { oilAPI, temperatureF, temperatureInRankine, gasSpecificGravity } =
      params;
    const {
      solutionGasRsoAtReservoir: solutionGasRsoAtReservoirLocal,
      gasSGatSeparatorYgPsp
    } = solutionGasRsoCalculator(params);
    const solutionGasRsoAtReservoir =
      params.solutionGasRsoAtReservoir ?? solutionGasRsoAtReservoirLocal;

    // D178: =31.7648*(((J15/D8)^0.7857)*((10^(0.0009*D4))/(10^(0.0148*D7))))
    const bubblePointPressurePSIA_gt_31 =
      31.7648 *
      ((solutionGasRsoAtReservoir / gasSpecificGravity) ** 0.7857 *
        (10 ** (0.0009 * temperatureF) / 10 ** (0.0148 * oilAPI)));
    // D180: =(J15/(0.09902*(D156^0.2181)*10^((7.2153*D7)/D15)))
    const bubblePointPressurePSIA_22_31 =
      solutionGasRsoAtReservoir /
      (0.09902 *
        gasSGatSeparatorYgPsp ** 0.2181 *
        10 ** ((7.2153 * oilAPI) / temperatureInRankine));
    // D182: =((56.434*J15)/(D156*10^(10.9267*(D7/D15))))^(1/1.2057)
    const bubblePointPressurePSIA_10_22 =
      ((56.434 * solutionGasRsoAtReservoir) /
        (gasSGatSeparatorYgPsp *
          10 ** (10.9267 * (oilAPI / temperatureInRankine)))) **
      (1 / 1.2057);
    // D184: =((J15/D8)^(1/1.1128))*(10.7025/(10^(0.0169*D7-0.00156*D4)))
    const bubblePointPressurePSIA_lt_10 =
      (solutionGasRsoAtReservoir / gasSpecificGravity) ** (1 / 1.1128) *
      (10.7025 / 10 ** (0.0169 * oilAPI - 0.00156 * temperatureF));

    // D186: =IF(D11>0,D11,IF(D7<=10,D184,IF(AND(D7>10,D7<=22.3),D182,IF(AND(D7<=31.1,D7>22.3),D180,D178))))
    let bubblePointPressurePSIA = 0;
    if (oilAPI > 31.1) {
      bubblePointPressurePSIA = bubblePointPressurePSIA_gt_31;
    } else if (oilAPI > 22.3 && oilAPI <= 31.1) {
      bubblePointPressurePSIA = bubblePointPressurePSIA_22_31;
    } else if (oilAPI > 10 && oilAPI <= 22.3) {
      bubblePointPressurePSIA = bubblePointPressurePSIA_10_22;
    } else {
      bubblePointPressurePSIA = bubblePointPressurePSIA_lt_10;
    }
    return {
      gasSGatSeparatorYgPsp,
      temperatureInRankine,
      solutionGasRsoAtReservoir,
      oilAPI,
      bubblePointPressurePSIA_gt_31,
      bubblePointPressurePSIA_22_31,
      bubblePointPressurePSIA_10_22,
      bubblePointPressurePSIA_lt_10,
      bubblePointPressurePSIA
    };
  };
